import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "infobox-container pe-0" }
const _hoisted_5 = { class: "infobox position-relative" }
const _hoisted_6 = { class: "infobox-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.dat.de/sachverstaendige/",
  target: "_blank",
  rel: "noopener"
}, "Jetzt Termin anfragen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningTriangleIcon = _resolveComponent("WarningTriangleIcon")!

  return (_ctx.showElement())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "shorteval-hsn-tsn-warning-component mb-2",
        id: `element-${_ctx.name}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_WarningTriangleIcon, { class: "me-2" }),
                  _createElementVNode("div", null, [
                    (_ctx.carCountHsnTsn === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createTextVNode("Das von Ihnen angegebene Fahrzeug kann leider nicht identifiziert werden. Bitte überprüfen Sie Ihre Eingabe. Fahrzeuge mit einem Alter von mehr als 12 Jahren sind von der kostenfreien Bewertung ausgeschlossen. Ihr DAT Expert Partner hilft Ihnen gerne bei der Wertermittlung."),
                          _hoisted_8,
                          _hoisted_9
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}